import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  landmark: [],
  allLandmark: []
};

export const LandmarksSlice = createSlice({
  name: "landmarks",
  initialState,
  reducers: {
    getAllLandmarkAction: (state, action) => {
      state.allLandmark = action.payload;
    },
    getLandmarkAction: (state, action) => {
      state.landmark = action.payload;
    },
  },
});

export default LandmarksSlice.reducer;

export const { getAllLandmarkAction, getLandmarkAction } = LandmarksSlice.actions;
